/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type IngredientRecipeModal_allIngredients$ref: FragmentReference;
declare export opaque type IngredientRecipeModal_allIngredients$fragmentType: IngredientRecipeModal_allIngredients$ref;
export type IngredientRecipeModal_allIngredients = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +name: string,
    |}
  |}>,
  +$refType: IngredientRecipeModal_allIngredients$ref,
|};
export type IngredientRecipeModal_allIngredients$data = IngredientRecipeModal_allIngredients;
export type IngredientRecipeModal_allIngredients$key = {
  +$data?: IngredientRecipeModal_allIngredients$data,
  +$fragmentRefs: IngredientRecipeModal_allIngredients$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IngredientRecipeModal_allIngredients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IngredientNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IngredientNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IngredientNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '95c82fcb13d05045b76a7ee318a25dc9';

module.exports = node;
